module.exports = __webpack_public_path__ + "static/media/DSC_0205.ab6df4b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0205.jpg
// module id = 567
// module chunks = 0